<!-- ItemMenu.svelte -->
<script>
  import { navigate } from "svelte-routing";
  import { permissaoUsuario } from "../Classes/Stores";
  import { logado, atualizarLogado } from "../Classes/EstadoLogado";
  import { createEventDispatcher, onMount } from "svelte";
    import Constantes from "../Classes/Constantes";
  
  const dispatch = new createEventDispatcher();
  let logadoValor = false;
  export let item = {};
  // Assine as mudanças no valor de logado
  const unsubscribe = logado.subscribe((value) => {
    logadoValor = value;
  });

  onMount(() => {
    // Limpe a assinatura quando o componente for destruído para evitar vazamentos de memória
    return unsubscribe;
  });
  function NavegarPara(item) {
    //console.log(item.navegarPara);
    if (item.logout) {
      localStorage.setItem("token", "");
      localStorage.setItem("usuario", "");
      localStorage.setItem("id_empresa", "");
      Constantes.logado = false;
      atualizarLogado(false);

      navigate("/")
    }
    navigate(item.navegarPara);
    dispatch("close");
  }

  
</script>

{#if (item.SoLogado == false || (item.SoLogado && $logado)) && (item.login!=true && $logado)}
  {#if item.permissao == "" || ($permissaoUsuario &&  (item.permissao in $permissaoUsuario.permissoes || $permissaoUsuario.permissoes.includes(item.permissao) ) )}
    <div class="item-menu" on:click={NavegarPara(item)}>
      <div class="icone">
        {#if item.icone}
          <i class={item.icone}></i>
        {/if}
      </div>
      <div class="nome">{item.nome}</div>
    </div>
  {/if}
{:else if (item.login==true && !$logado)}

<div class="item-menu" on:click={NavegarPara(item)}>
      <div class="icone">
        {#if item.icone}
          <i class={item.icone}></i>
        {/if}
      </div>
      <div class="nome">{item.nome}</div>
    </div>
{/if}

<style>
  .item-menu {
    display: flex;
    align-items: center;
    padding: 10px;
  }

  .icone {
    margin-right: 10px;
  }

  .icone i {
    font-size: 20px; /* Ajuste o tamanho do ícone conforme necessário */
    color: #333; /* Cor do ícone */
  }
</style>
